import { type ProcessedOption } from "@/components/site-builder/modules/CustomFormModule/types";

export function flattenTreeForRender(
  options: ProcessedOption[],
): ProcessedOption[] {
  return options.flatMap((option) => {
    const result: ProcessedOption[] = [option];

    if (option.childOptions && option.childOptions.length > 0) {
      result.push(...flattenTreeForRender(option.childOptions));
    }

    return result;
  });
}
